/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Not_FoundInputs */

const en_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course not found.`)
};

const ja_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースが見つかりません。`)
};

const fr_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours non trouvé.`)
};

const de_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Course not found." |
*
* @param {Player_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_not_found = /** @type {((inputs?: Player_Not_FoundInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Not_FoundInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_not_found(inputs)
	if (locale === "ja") return ja_player_not_found(inputs)
	if (locale === "fr") return fr_player_not_found(inputs)
	return de_player_not_found(inputs)
});